import * as React from 'react';
export default function SvgLayers() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.62 4.103a.75.75 0 01.76 0l7.25 4.25a.75.75 0 010 1.294l-7.25 4.25a.75.75 0 01-.76 0l-7.25-4.25a.75.75 0 010-1.294l7.25-4.25zM6.234 9L12 12.38 17.767 9 12 5.62 6.233 9z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.045 11.589a.75.75 0 011.038-.216l4.578 3a.75.75 0 01-.032 1.274l-7.25 4.25a.75.75 0 01-.758 0l-7.25-4.25a.75.75 0 01-.037-1.271l4.5-3a.75.75 0 01.832 1.248l-3.503 2.335L12 18.381l5.828-3.417-3.567-2.337a.75.75 0 01-.216-1.038z",
    fill: "currentColor"
  }));
}